/* Collection Repaginate
   The collection grid hides tagged products (OOS/Hidden/Retired/Enrollment/
   Sold Out) after Shopify paginates, which leaves pages short. This fetches
   every server page once, combines the visible product cards, and re-slices
   them into full pages with rebuilt pagination. */
(function () {
  var GRID_SELECTOR = 'ul.product-grid';
  var NAV_SELECTOR = 'nav.pagination';

  function serverPages(nav) {
    var max = 1;
    nav.querySelectorAll('[data-page]').forEach(function (a) {
      var n = parseInt(a.getAttribute('data-page'), 10);
      if (n > max) max = n;
    });
    nav.querySelectorAll('span').forEach(function (s) {
      var n = parseInt(s.textContent.trim(), 10);
      if (n > max) max = n;
    });
    return max;
  }

  function pageUrl(n) {
    var url = new URL(window.location.href);
    if (n > 1) url.searchParams.set('page', n);
    else url.searchParams.delete('page');
    return url.toString();
  }

  function fetchPageItems(n) {
    return fetch(pageUrl(n)).then(function (r) {
      if (!r.ok) throw new Error('page ' + n + ' failed');
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = doc.querySelector(GRID_SELECTOR);
      return grid ? Array.prototype.slice.call(grid.children) : [];
    });
  }

  function run(section) {
    var grid = section.querySelector(GRID_SELECTOR);
    var nav = section.querySelector(NAV_SELECTOR);
    if (!grid || grid.dataset.repaginated) return;
    grid.dataset.repaginated = '1';

    // Hero products render outside the grid but count as visible
    var heroCount = section.querySelectorAll('.collection-hero-product').length;

    function updateCounts(total) {
      section.querySelectorAll('[data-visible-count]').forEach(function (el) {
        el.textContent = el.textContent.replace(/\d[\d.,]*/, total);
      });
    }

    var perPage = parseInt(grid.dataset.perPage, 10) || 48;
    var pages = nav ? serverPages(nav) : 1;
    if (pages < 2) {
      updateCounts(grid.children.length + heroCount);
      return;
    }

    // Preserve the theme's arrow icons for the rebuilt nav
    var prevIcon = nav.querySelector('a[rel="prev"]');
    var nextIcon = nav.querySelector('a[rel="next"]');
    var icons = {
      prev: prevIcon ? prevIcon.innerHTML : (nextIcon ? nextIcon.innerHTML : '&larr;'),
      next: nextIcon ? nextIcon.innerHTML : (prevIcon ? prevIcon.innerHTML : '&rarr;')
    };

    var requests = [];
    for (var n = 1; n <= pages; n++) requests.push(fetchPageItems(n));

    Promise.all(requests).then(function (pageItems) {
      if (!grid.isConnected) return; // section re-rendered mid-fetch
      var master = [].concat.apply([], pageItems);
      if (!master.length) return;

      updateCounts(master.length + heroCount);

      var totalPages = Math.ceil(master.length / perPage);
      var current = parseInt(new URL(window.location.href).searchParams.get('page'), 10) || 1;
      if (current > totalPages) current = totalPages;

      function render(page, scroll) {
        current = page;
        grid.innerHTML = '';
        master.slice((page - 1) * perPage, page * perPage).forEach(function (li) {
          grid.appendChild(document.importNode(li, true));
        });
        renderNav();
        history.replaceState({}, '', pageUrl(page));
        if (scroll) grid.closest('[id^="shopify-section-"]').scrollIntoView({ behavior: 'smooth' });
      }

      function navItem(inner) {
        var li = document.createElement('li');
        li.className = 'pagination__nav-item';
        li.appendChild(inner);
        return li;
      }

      function navLink(page, html, cls, rel, label) {
        var a = document.createElement('a');
        a.href = pageUrl(page);
        a.setAttribute('data-page', page);
        if (cls) a.className = cls;
        if (rel) a.setAttribute('rel', rel);
        a.setAttribute('aria-label', label || 'Go to page ' + page);
        a.innerHTML = html;
        a.addEventListener('click', function (e) {
          e.preventDefault();
          render(page, true);
        });
        return a;
      }

      function renderNav() {
        var oldNav = section.querySelector(NAV_SELECTOR);
        if (totalPages < 2) {
          if (oldNav) oldNav.remove();
          return;
        }
        var newNav = document.createElement('nav');
        newNav.className = 'pagination small-caption';
        var ul = document.createElement('ul');
        ul.className = 'pagination__nav';
        ul.setAttribute('role', 'list');

        if (current > 1) {
          ul.appendChild(navItem(navLink(current - 1, icons.prev, null, 'prev', 'Previous page')));
        }
        for (var p = 1; p <= totalPages; p++) {
          if (p === current) {
            var span = document.createElement('span');
            span.className = 'pagination__nav-item heading heading--small';
            span.setAttribute('aria-current', 'page');
            span.textContent = p;
            ul.appendChild(navItem(span));
          } else {
            ul.appendChild(navItem(navLink(p, p, 'heading heading--small')));
          }
        }
        if (current < totalPages) {
          ul.appendChild(navItem(navLink(current + 1, icons.next, null, 'next', 'Next page')));
        }
        newNav.appendChild(ul);
        if (oldNav) oldNav.replaceWith(newNav);
        else grid.parentNode.appendChild(newNav);
      }

      render(current, false);
    }).catch(function () {
      /* leave server-rendered page + pagination untouched */
      delete grid.dataset.repaginated;
    });
  }

  function init() {
    document.querySelectorAll('[id^="shopify-section-"] ' + GRID_SELECTOR).forEach(function (grid) {
      var section = grid.closest('[id^="shopify-section-"]');
      if (section) {
        run(section);
        observe(section);
      }
    });
  }

  var observed = new WeakSet();
  function observe(section) {
    if (observed.has(section)) return;
    observed.add(section);
    new MutationObserver(function () {
      var grid = section.querySelector(GRID_SELECTOR);
      if (grid && !grid.dataset.repaginated) {
        run(section);
      }
    }).observe(section, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
